"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Workflow Automation
 * Worklow Automation API We  support the following components<ul> <li><b>Action (or Task)</b> - Predefined units of work that the system can perform. An action could be something like send an email or assign the shipment to this carrier. An action<ul> <li>Will have a name</li> <li>May specify inputs it takes</li> <li>May specify outputs it produces</li> <li>Could throw an Exception</li></ul> <li><b>Junction</b> - Specifies how the different steps are connected to each other (converging, diverging)</li> <li><b>Start</b> - There must be one at least one place to start</li> <li><b>End</b> - Marks the end of a process workflow </li> <li><b>Data objects</b> - these objects will be defined and maintained by the development team. These objects could be things like shipments, companies, users, tenders etc.</li> <li><b>Signals</b> - Workflow steps can listen for an incoming signal for things like triggering the next step, interrupting execution or triggering other flows. </li></ul>
 *
 * The version of the OpenAPI document: 0.1.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configuration = void 0;
var Configuration = /** @class */ (function () {
    function Configuration(param) {
        if (param === void 0) { param = {}; }
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
        this.baseOptions = param.baseOptions;
        this.formDataCtor = param.formDataCtor;
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    Configuration.prototype.isJsonMime = function (mime) {
        var jsonMime = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    };
    return Configuration;
}());
exports.Configuration = Configuration;
